
export const config = {
	title:"NaviTrack Octopus",
	apiUrl: 'https://api.fcs.navitrack.com.ua',
	baseUrl: 'https://fcs.navitrack.com.ua',
	loginUrl: "user/login",
	telegram: {
		enabled: true
	},
	viber: {
		enabled: false
	},
	googleMaps: {
		enabled: true,
		key: "AIzaSyDMroRgjYMvJBJFuOE4FGF07R9y9jgncXk",
		libraries: "places"
	},
	userInactivity: {
		enabled: false
	},
	eusign: {
		enabled: false
	},
	checkEmailCode: {
		enabled: false
	}
};